import * as React from 'react';

/**
 * Provides a `copy(text)` function and a `copied` boolean that auto-resets
 * after `resetMs` milliseconds. Use this instead of inlining the
 * navigator.clipboard + setTimeout pattern.
 */
export function useCopyToClipboard(resetMs = 2000) {
  const [copied, setCopied] = React.useState(false);

  const copy = React.useCallback(
    async (text: string) => {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), resetMs);
    },
    [resetMs]
  );

  return { copied, copy };
}
